var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdeal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff48d",
  d: "M0 0h40v26H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.936 7.805V18.21c0 .498.41.905.91.905h6.247c4.722 0 6.769-2.63 6.769-6.121 0-3.49-2.048-6.094-6.77-6.094H3.846a.91.91 0 0 0-.91.905"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#c06",
  d: "M7.117 9.454v7.688h3.362c3.052 0 4.376-1.716 4.376-4.143s-1.324-4.124-4.376-4.124h-2.78a.58.58 0 0 0-.582.58z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  fillRule: "evenodd",
  d: "M4.66 18.287h5.431c3.817 0 5.923-1.879 5.923-5.289 0-1.964-.769-5.265-5.923-5.265H4.66a.87.87 0 0 0-.874.87v8.815c0 .48.391.87.874.87zm-.583-9.685c0-.32.26-.58.582-.58h5.432c2.101 0 5.631.648 5.631 4.976 0 3.224-2.001 4.999-5.631 4.999H4.66a.58.58 0 0 1-.582-.58z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.77 11.88a1 1 0 0 0-.325-.054v-.005h-.77v1.857h.78a.9.9 0 0 0 .36-.073.74.74 0 0 0 .405-.495 1.4 1.4 0 0 0-.013-.777 1 1 0 0 0-.173-.284.7.7 0 0 0-.263-.17zm-.182 1.433a.6.6 0 0 1-.17.027v.005h-.35v-1.171h.284a.6.6 0 0 1 .244.041.4.4 0 0 1 .16.124.5.5 0 0 1 .09.192c.017.073.027.16.027.252a.8.8 0 0 1-.04.26.5.5 0 0 1-.102.174.33.33 0 0 1-.143.096",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.876 11.827v.343h-.953v.398h.877v.316h-.877v.453h.975v.344h-1.37v-1.857h1.348z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m12.914 13.683-.677-1.856h-.413l-.681 1.856h.4l.143-.412h.676l.138.412zm-.882-1.4.227.682h-.466l.235-.681z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.56 11.826v1.514h.881v.343h-1.277v-1.856z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  d: "M5.555 13.71a.873.873 0 1 0 0-1.744.873.873 0 0 0 0 1.745m.519 3.493c-.676 0-1.218-.584-1.218-1.3v-1.016c0-.359.271-.653.611-.653s.611.29.611.653v2.316z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1c1c",
  d: "M33.034 13.05c0-1.021.726-1.95 1.98-1.95S37 12.03 37 13.05 36.274 15 35.014 15c-1.254 0-1.98-.93-1.98-1.95m2.864 0c0-.492-.325-.946-.884-.946s-.883.454-.883.946c0 .49.33.946.883.946.554 0 .884-.454.884-.946m-3.634.724c.417-.238.668-.692.668-1.194 0-.745-.538-1.38-1.374-1.38h-1.755v3.7h1.087v-.946h.203l.622.946h1.28zm-.925-.672h-.45v-1.046h.455c.293 0 .48.238.48.523s-.193.523-.485.523m-6.499-1.907-.652 2.205-.637-2.205h-.865l-.642 2.205-.647-2.205H20.25l1.314 3.694h.944l.61-2.011.605 2.01h.949l1.314-3.693zm2.793 2.792h-.002a.85.85 0 0 1-.814-.57h2.762q.033-.185.033-.374c0-1.018-.724-1.946-1.98-1.947v1.002c.41.001.692.247.813.57h-2.758a2 2 0 0 0-.034.375c0 1.018.725 1.947 1.977 1.947h.002z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M27.629 14.99q.064 0 .126-.004.382-.021.69-.148a1.8 1.8 0 0 0 .92-.817q.135-.247.196-.524H28.41a1 1 0 0 1-.082.14.8.8 0 0 1-.342.278.9.9 0 0 1-.356.072.84.84 0 0 1-.619-.256l-.748.756c.332.308.794.501 1.366.501z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M27.63 11.095c-1.062 0-1.745.668-1.927 1.492h1.147a.84.84 0 0 1 .78-.49c.297 0 .527.129.677.322l.755-.763c-.337-.342-.822-.56-1.431-.56z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1c1c",
  d: "M18.542 17.121a.153.153 0 0 1-.152-.152V9.036a.153.153 0 1 1 .305 0v7.933a.153.153 0 0 1-.153.152"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 29,
  x2: 27.282,
  y1: 12.827,
  y2: 14.93,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#1d1c1c",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#1d1c1c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 26.004,
  x2: 27.765,
  y1: 13.273,
  y2: 11.533,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#1d1c1c",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#1d1c1c"
})))));
export { SvgIdeal as ReactComponent };
export default "/_next/static/images/ideal.svg";